/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_extent_agg.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculate the spatial extent over a field with geometry type. Returns a bounding box for all values of the field.
 *
 * @example
 * FROM airports
 * | WHERE country == "India"
 * | STATS extent = ST_EXTENT_AGG(location)
 */
const definition: FunctionDefinition = {
  type: 'agg',
  name: 'st_extent_agg',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_shape',
    },
    {
      params: [
        {
          name: 'field',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_shape',
      license: 'PLATINUM',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_shape',
    },
    {
      params: [
        {
          name: 'field',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_shape',
      license: 'PLATINUM',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
